import { KyInstance } from 'ky';

import { handleRequest } from '@/utils/httpUtils';

import {
  Order,
  OrderResponse,
  Profile,
  ProfileResponse,
  Token,
  TokenResponse,
  Widget,
  WidgetResp,
} from './types';

export interface IReqUPS {
  token: Token;
  widget: Widget;
  profile: Profile;
  order: Order;
}

export function reqUPS(http: KyInstance): IReqUPS {
  const route = 'api/v1';
  return {
    token: (args) =>
      handleRequest<TokenResponse>(http, 'post', `${route}/user/token`, { json: args }),
    widget: () => handleRequest<WidgetResp>(http, 'get', `${route}/user/widget`),
    profile: () => handleRequest<ProfileResponse>(http, 'get', `${route}/user/profile`),
    order: () => handleRequest<OrderResponse>(http, 'get', `${route}/orders`),
  };
}
